<template>
  <v-app class="bcgrnd">
    <v-container fluid grid-list-md text-xs-center style="background-color:#f4f4f4 ;padding: 0;" >
      <v-card flat style="background-color:#f4f4f4" >
    <v-card-title style="padding:0px">
      <h5>Profile</h5>
      <v-spacer></v-spacer>



    <v-btn @click.stop="logOutDialog = true" round flat style="text-transform: unset !important ;background-color: #ffffff; ">
                        <!-- <avatar :size="32" :username="loggedInUserName"></avatar> -->
                        <v-icon color="warning" style="font-size:30px;">person</v-icon>

                       &nbsp;&nbsp;{{loggedInUserName}}
      <!-- <v-icon>arrow_drop_down</v-icon> -->

    </v-btn>

          <v-dialog v-model="logOutDialog" max-width="290" persistent>
            <v-card style="padding: 20px !important ; border-radius: 0px;border:1px solid;background-color:orange">
              <v-sheet color="transparent" style="text-align:center">
                <v-icon color="#0d47a1" :size="40">https</v-icon>
              </v-sheet>
              
              <h3 style="text-align:center;font-size:20px;color:red">Logout</h3>

   <v-card-text style="text-align:center;color:black">Are you sure you want to logout from Worldwin ?</v-card-text>

              
                <v-btn style="padding-left:60px" dark color="green" flat @click="logOutDialog = false">No</v-btn>&nbsp;&nbsp;
                <v-btn dark color="red" flat @click="logOut()">Yes</v-btn>
            </v-card>
          </v-dialog>
    </v-card-title>
  </v-card>
    </v-container>
  

    <v-container v-if="mydata!=null" style="max-width:1350px">
    <v-layout row wrap class="my-2 mx-2" >


      <v-flex xs12 sm12 md12>
        <template>
          <v-card >
            <div class="">
              <div class="row">
                <div class="col-lg-6">
                    <div style="display:flex; align-items: center; padding: 30px;">
                      <v-avatar style="margin-right:10px;border:1px solid;" v-if="showPic==true&&profilePic!=null">
                          <v-img
                            :src="profilePic"
                            alt="John"
                          ></v-img>
                        </v-avatar>
                        <v-avatar style="margin-right:10px;border:1px solid;" v-if="showPic==false||profilePic==null">
                          <v-img
                            src="https://w7.pngwing.com/pngs/708/467/png-transparent-avatar-default-head-person-unknown-user-anonym-user-pictures-icon.png"
                            alt="John"
                          ></v-img>
                        </v-avatar>
                        <v-icon @click="onDialog()" style="margin-left: -25px;margin-top: 30px;background-color: #f4f4f4;">photo_camera</v-icon>
                        <h4 style="color:#F09522">{{mydata.firstName}} <span>{{mydata.lastName}}</span> <!--  <span style="font-size:16px">({{ mydata.levelName }})</span> --></h4>

                    </div>
                  </div>

                  <div class="col-lg-6 res" style="display:flex; justify-content:end;">
                  
                   <v-btn
                   size="small"
                   class="me-2 text-none"
                   >
                   &nbsp;&nbsp;
                   <v-icon color="#AC19BA">school</v-icon>
                      View Training Details
                   </v-btn>

                   <v-btn
                   size="small"
                   class="text-none "
                   variant="text"
                   >
                   &nbsp;&nbsp;
                   <v-icon color="#0E9A57">description</v-icon>

                   View Application Details
                   </v-btn>                       

         </div>
                  <div class="col-lg-6 man" style="display:flex; justify-content:end;">
                  
                         <div class="col-lg-6">
                          <v-btn
                          size="small"
                          class="me-2 text-none"
                          >
                          <v-icon color="#AC19BA">school</v-icon>
                             View Training Details
                          </v-btn>

                          <v-btn
                          size="small"
                          border
                          class="text-none mt-2"
                          variant="text"
                          >
                          <v-icon color="#0E9A57">description</v-icon>

                          View Application Details
                          </v-btn>                       
                  </div>

                </div>


              </div>
              <div class="row " style="margin-top: 50px;">
                <div class="col-lg-4">
                  <v-card
                      class="mx-auto  "
                      style="color: #D9255B;border-radius: 30px;   border:solid 2px #D9255B;">

                  <h6>Email</h6>
                    <p>{{mydata.email}}</p>
                    </v-card>

                </div>
                <div class="col-lg-3">
                  <v-card
                      class="mx-auto  "
                      style="color: #AC19BA;border-radius: 30px;   border:solid 2px #AC19BA;">
                    <h6>Mobile number</h6>
                    <p>{{mydata.mobileNumber}}</p>
                  </v-card>

                </div>
                <div class="col-lg-2">
                  <v-card
                      class="mx-auto  "
                      style="color: #004DCB;border-radius: 30px;   border:solid 2px #004DCB;"> 
                   <h6>Nature</h6>
                    <p>{{mydata.nature}}</p>
                  </v-card>
                </div>
                <div class="col-lg-3">
                  <v-card
                      class="mx-auto  "
                      style="color:#004DCB;border-radius: 30px;   border:solid 2px #004DCB;">

                  <h6>Guardian Name</h6>
                    <p>{{mydata.guardianName}}</p>
                    </v-card>

                </div>
              </div>
              <div class="row " style="">
                
                <div class="col-lg-4">
                  <v-card
                      class="mx-auto  "
                      style="color: #AC19BA;border-radius: 30px;   border:solid 2px #AC19BA;">
                    <h6>Guardian number</h6>
                    <p>{{mydata.guardianNo}}</p>
                  </v-card>

                </div>
                <div class="col-lg-4">
                  <v-card
                      class="mx-auto  "
                      style="color: #D9255B;border-radius: 30px;   border:solid 2px #D9255B;"> 
                   <h6>Guardian Email</h6>
                    <p>{{mydata.guardianEmail}}</p>
                  </v-card>
                </div>
                <div class="col-lg-4">
                  <v-card
                      class="mx-auto  "
                      style="color: #0E9A57;border-radius: 30px;   border:solid 2px #0E9A57;"> 
                    <h6>Relation</h6>
                    <p>{{mydata.relation}}</p>
                  </v-card>
                </div>
              </div>
                 <div class="row">
                    <div class="col-lg-2" v-for="item in mydata.leadTrainings" :key="item.id">
                      <v-card style="background-color: #D63224; padding: 10px; text-align: center;border-radius: 30px;">
                        <h4 style="color:#ffffff;margin-bottom: 0;" >{{ item.name }}</h4>
                      </v-card>
                    </div>
                 </div>
              <div class="row">
                 <div class="col-lg-12">
                  <v-card style="border: 2px solid #F09522; background-color: #FFF2E2;border-radius:30px;">
                    <div class="table-responsive">

                  <table class="table">
                    <thead class="table-light" style=" text-align: center;font-weight: 700;background-color: #FFF2E2;">
                      <tr style=" ">
                        <td>QUALIFICATION</td>
                        <td>STREM / COURSE</td>
                        <td>BORAD / UNIVERSITY</td>
                        <td>YEAR OF JOINNING</td>
                        <td>YEAR OF PASSING</td>
                        <td>PERCENTAGE</td>
                      </tr>
                    </thead>
                    <tbody class="table-tbody">
                      <tr>
                        <td>10th</td>
                        <td>{{mydata.xstream}}</td>
                        <td>{{mydata.xboard}}</td>
                        <td>{{mydata.xstart}}</td>
                        <td>{{mydata.xend}}</td>
                        <td>{{mydata.xmark}}</td>
                      </tr>
                      <tr>
                        <td>12th</td>
                        <td>{{mydata.xiistream}}</td>
                        <td>{{mydata.xiiboard}}</td>
                        <td>{{mydata.xiistart}}</td>
                        <td>{{mydata.xiiend}}</td>
                        <td>{{mydata.xiimark}}</td>
                      </tr>
                      <tr>
                        <td>Graduation</td>
                        <td>{{mydata.gradstream}}</td>
                        <td>{{mydata.gradboard}}</td>
                        <td>{{mydata.gradstart}}</td>
                        <td>{{mydata.gradend}}</td>
                        <td>{{mydata.gradmark}}</td>
                      </tr>
                      <tr>
                        <td>Masters</td>
                        <td>{{mydata.masterstream}}</td>
                        <td>{{mydata.masterboard}}</td>
                        <td>{{mydata.masterstart}}</td>
                        <td>{{mydata.masterend}}</td>
                        <td>{{mydata.mastermark}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                </v-card>
                 </div>
              </div>
              <div class="row">

                <!-- <div class="col-lg-6">
                <v-card
                    style="border-radius:30px;  border:solid 2px #D63224 ; "    >
                          <h5 style="color: #D63224;text-align: center;">Notes</h5>
                          <v-divider :thickness="3" color="#D63224"></v-divider>

                            <p>{{mydata.notes}}</p>
                    </v-card>
                  </div> -->
                  <div class="col-lg-12">
                    <v-card
                    style="border-radius:30px;  border:solid 2px #D63224; text-align: center;"    >
                          <h5 style="color: #D63224;">Details of Documents</h5>
                          <v-divider :thickness="3" color="#D63224"></v-divider>
<!-- 
                            <h6>{{mydata.documentType}}</h6> -->
                            <v-tabs
      v-model="tab"
      bg-color="transparent"
      color="basil"
      grow
    >

      <v-tab
      >
      Lead document
      </v-tab>
      <v-btn large style="background-color: #128f31; color: #ffffff; margin-left: 10px;" @click="onAddLead()">Add Document</v-btn>

      <!-- <v-tab
      >
      Application Document
      </v-tab> -->
    </v-tabs>

    <v-window v-model="tab">
      <v-window-item
      >
        <v-card
          color="basil"
          flat
        >
        <div class="container">
          <div class="row">
            <div class="col-lg-3" v-for="item in list" :key="item.id">
              <v-card style="border: 2px solid #F09522;padding:12px 0px; background-color: #fffbf5;border-radius:10px;">
                <div class="docs">
                  <p> <strong>{{item.name}}</strong> </p>
                  <a :href="item.src" target="_blank">
                  <v-icon medium style="background-color:#0E9A57;padding:10px; border-radius:50%;cursor: pointer;"  color="white" >cloud_download</v-icon>
                </a>

                </div>
              </v-card>
            </div>     
             </div>
        </div>
        </v-card>
      </v-window-item>
      <!-- <v-window-item
      >
        <v-card
          color="basil"
          flat
        >
        <div class="container">
          <div class="row">
            <div class="col-lg-3" v-for="item in list1" :key="item.id">
              <v-card style="border: 2px solid #F09522;padding:12px 0px; background-color: #fffbf5;border-radius:10px;">
                <div class="docs">
                  <p> <strong>{{item.name}}</strong> </p>
                  <a :href="item.src" target="_blank">
                  <v-icon medium style="background-color:#0E9A57;padding:10px; border-radius:50%;cursor: pointer;"  color="white" >cloud_download</v-icon>
                </a>

                </div>
              </v-card>
            </div>     
             </div>
        </div>
         </v-card>
      </v-window-item> -->
    </v-window>
                            
                    </v-card>

                    
                </div>
              </div>
            </div>


          </v-card>
        </template>
        </v-flex>

    </v-layout>
  </v-container>

  <v-dialog v-model="photoDialog" width="500">
    <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
        Profile Photo Upload
        </v-card-title>

        <v-card-text>
         <v-form ref="form" v-model="valid" lazy-validation style="padding-top: 30px;">
          <v-layout row wrap>
            <v-flex xs12>
              <input type="file" ref="myFile" @change="selectedFile"  class="padding" accept="image/*">
            </v-flex>
            <v-flex xs12>
              <h6 v-if="imagelink != null">Image Size : {{image.size}}</h6>
              <h6 class="red--text">{{imageError}}</h6>
            </v-flex>
          </v-layout>
      </v-form>
        </v-card-text>
       
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-spacer></v-spacer>
       <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            :loading="btnSave"
            @click="_onSubmit()"
          >
            UPLOAD
          </v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>

  </v-app>
</template>

<script>

//import Vue from "vue";
import config from "../../config1.json";
export default {
  components: {
  },
  data() {
    return {
      tab: false,
      roleType: sessionStorage.roles,
      loggedInUserName: sessionStorage.loggedInUserName,
      logOutDialog: false,
      customerNo: 0,
      productNo: 0,
      presentOrderList: [],
      presentOrder: 0,
      presentOrderAmount: 0,
      btnSave: false,
      deliveredOrderAmount: 0,
      deliveredOrder: 0,
      mydata: null,
      list: [],
      list1: [],
      profilePic: null,
      showPic: false,
      photoDialog: false,

      imagelink: null,
      imageError:'',
      image:{
      size:'',
      height:'',
      width:''
      },
      imageLoaded:false,
      type: null,
      
      search: "",
      tableHeader: [
        { text: "#",
        align: 'left',
          sortable: false, value: "index" },
        { text: "Order Code", value: "orderCode" },
        { text: "Order Date", value: "date" },
        { text: "Customer Name", value: "fullName" },
        { text: "Mobile Number", value: "mobileNumber" },
        { text: "Total Amount", value: "totalPrice" },
        { text: "Status", value: "status" },
        { text: "Action", value: "action" }
      ]
    };
  },

  methods: {
    onTrainingProcess() {
      this.$router.push("/studentTrainingProcess");
    },
    onAddLead() {
      this.$router.push("/addLead");
    },
    onApplicationProcess() {
      this.$router.push("/studentApplicationProcess");
    },
    getData() {
      let id = sessionStorage.getItem("loggedInUserID");
      this.axios
      .get(config.API + 'Admin/' + id, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        let studentId = res.data.studentId;

        this.axios
        .get(config.API + "Leads/" + studentId, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.mydata = res.data;
          this.profilePic = this.mydata.profileSrc;
          this.showPic = this.mydata.showPic;
          this.$Progress.finish();
        })
        .catch(err => {
          this.$toaster.error(err.message);
          this.$Progress.fail();
        });

        this.axios
        .get(config.API + "LeadDocuments/" + studentId, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.list = res.data;
          console.log(this.list);
          this.$Progress.finish();
        })
        .catch(err => {
          this.$toaster.error(err.message);
          this.$Progress.fail();
        });

        this.axios
        .get(config.API + "AppDoc/" + studentId, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.list1 = res.data;
          console.log(this.list1);
          this.$Progress.finish();
        })
        .catch(err => {
          this.$toaster.error(err.message);
          this.$Progress.fail();
        });
      });
    },

    onDialog() {
      if(this.photoDialog==false) {
        this.photoDialog=true;
      }
      else {
        this.photoDialog=false;
      }
    },

    selectedFile() {
      this.imageLoaded = false;
      this.imageError = '';

      let file = this.$refs.myFile.files[0];
      this.imagelink = file;
      this.type = file.type;

      if(!file || file.type.indexOf('image/') !== 0) return;
      
      this.image.size = file.size;

      if(this.image.size > 500000) {
        this.imageError = `The image size (${this.image.size}) is too much (max is 500 KB).`;
        return;
      }
      
      let reader = new FileReader();
      
      reader.readAsDataURL(file);
      reader.onload = evt => {
        let img = new Image();
        img.onload = () => {
          this.image.width = img.width;
          this.image.height = img.height;
          this.imageLoaded = true;
        }
        img.src = evt.target.result;
      }

      reader.onerror = evt => {
        console.error(evt);
      }
    },

    _onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        if(this.type == 'image/jpeg' || this.type == 'image/png' || this.type == 'image/jpg') {
          const fd = new FormData();
          fd.append("image", this.imagelink, this.imagelink.name);
                this.axios
                 .post(config.API + `LeadImage/${this.mydata.id}`, fd, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                })
        .then(() => {
          this.$toaster.success("Successfully updated");
          window.location.reload();
        })
        .catch(err => {
          this.$toaster.error(err.message);
        });
              }
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    onEdit(item) {
      this.$router.push(`/viewSalesOrder/${item.id}`);
    },

    logOut() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    },
  },


  created() {
    this.getData();
  }
};
</script>

<style scoped>
.docs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding:0px 15px;
}
.docs p {
  margin-bottom: 0px;
}
.bcgrnd {
  background-color: white !important;
  background-size: cover;
}
.v-card {
  padding: 25px;
  letter-spacing: 0.5px;
}
.v-sheet--offset {
  top: -50px;
  position: relative;
}
.txt_dec:hover {
    text-decoration: none !important;
}
.flashing_effect {
  background-color: green !important;
  /* background-image: linear-gradient(-90deg, #f44336, #280071); */
  /* padding: 12px 15px; */
  animation-name: flashing;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
@keyframes flashing{
  0% {
     opacity: 1.0;
  }
  25% {
     opacity: 0.6;
  }
  50% {
     opacity: 0.3;
  }
  75% {
     opacity: 0.6;
  }
  100% {
     opacity: 1.0;
  }
}
marquee {
  height: 85%;
}
.hvr:hover {
  cursor: pointer;
  color: #3486D7;
  text-decoration: underline;
}
.das-card i{
   font-size: 30px;
   margin-right: 8px;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
.mobile-heading {
  font-size: 30px;
}
}
@media screen and (min-width: 768px){
  .man {
    display: none!important;
  }
}

.das-card {
  text-align: center;
}
.table-light tr td{
  /* font-size: 18px!important;  */
  color: #F09522;
}
.table-light tr{

}
.table-tbody tr td{
  text-align: center;
   /* font-size: 18px!important; */
}
</style>
